import React, { useState } from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Checkbox, FormControlLabel, Typography } from '@mui/material';
import { Cookie } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';
import GetCookie from '../Services/GetCookie';
import SetCookie from '../Services/SetCookie';

const CookieConsent = () => {
  const [open, setOpen] = useState(false);  // Le popup est fermé par défaut
  const [pageLoad, setPageLoad] = useState(true);


  if (pageLoad) {
    setPageLoad(false)
    try {
      if (GetCookie('cookiesAccepted') == undefined) {
        setOpen(true)
      }
    } catch (error) {
      setOpen(true)
    }

  }


  const handleClose = (val: boolean) => {
    SetCookie("cookiesAccepted", val)
    setOpen(false);
  };

  const { t, i18n } = useTranslation();

  return (
    <Dialog open={open} >
      <center>
        <DialogTitle>
          <Cookie style={{ width: "180px", height: "80px", color: 'orange' }} />
          <h4>{t("Texte.cookiesTitre")}</h4>
        </DialogTitle>
      </center>
      <center style={{ padding: "5%", marginTop: "-8%" }}>

        <label style={{ opacity: ".8" }}>
          {t("Texte.cookiesContenu")}
        </label>
        {/* <FormControlLabel
          control={
            <Checkbox
              checked={accepted}
              onChange={handleCheckboxChange}
              name="acceptCookies"
            />
          }
          label="I accept the use of cookies."
        /> */}

        <br /><br />
        <button style={{ marginRight: "10px" }} className='btn3' onClick={() => { handleClose(false) }}>
          {t("Texte.cookiesBtnRefuse")}
        </button>
        <button className='btn' onClick={() => { handleClose(true) }}>
          {t("Texte.cookiesBtnAccept")}
        </button>
      </center>
    </Dialog>
  );
};

export default CookieConsent;
